import { InviteStatus } from 'api/users/dtos'

export const getTagColorByInviteStatus = (status: InviteStatus) => {
	switch (status) {
		case InviteStatus.REJECTED:
			return 'volcano'
		case InviteStatus.PENDING:
			return 'gold'
		case InviteStatus.APPROVED:
		default:
			return 'green'
	}
}
